/**
 * Created by Amit Panghal
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {BitmapWinCountUp} from "@nolimitcity/slot-game/bin/game/winpresentation/countup/BitmapWinCountUp";
import {Power3, Timeline, TimelineLite, TweenLite, TweenMax} from "gsap";
import {TractorBeamGameModuleConfig} from "../TractorBeamGameModuleConfig";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";

export class TractorBeamInitialWinCountUp extends BitmapWinCountUp {

    private _isCountUpSoundPlaying:boolean = false;
    private _hasCountUpEndSoundPlayed:boolean = false;
    private _smallOrTiny:boolean = false;

    constructor() {
        super({
            font : {
                name : "yetiCountUp",
                size : 100
            },
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
    }

    private getScale(multiplier:number):number {
        return 1 + (multiplier - 1) * 0.1;
    }

    public getCountUpAnimation(from:number, to:number, duration:number, multiplier:number, smallOrTiny:boolean = false):Timeline {
        const oriNumber: number = (to / multiplier);
        const timeline:TimelineLite = new TimelineLite();
        this._smallOrTiny = smallOrTiny;

        timeline.add([
            () => {
                this._countUp.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.9 / this.getScale(multiplier);
                this._countUp.alpha = 1;
                this._countUp.visible = true;
                this._countUpContainer.scale.set(1, 1);
            },
            this._countUp.getCountUpAnimation(from, oriNumber, {duration : duration, ease : Power3.easeInOut}),
            (smallOrTiny)? () => TractorBeamGameModuleConfig.soundPlayer.stopCountUp(true) : ()=> {}
        ], (smallOrTiny)? 0.68 : 0);
        timeline.add(() => TweenMax.to(this._countUpContainer.scale, 0.1, {
            x: 1.07,
            y: 1.07,
            repeat: 1,
            yoyo: true
        }));

        return timeline;
    }

    onResize(data:IResizeData) {
        if(data.orientation === Orientation.PORTRAIT) {
            this._countUp.y = 100;
        }
        else {
            this._countUp.y = 0;
        }
    }

    public abort(endValue:number, isAborted:boolean, multiplier:number, isBigWin:boolean):Timeline | null {
        if(isBigWin) {
            return new TimelineLite();
        }

        if(isAborted) {
           //TractorBeamGameModuleConfig.soundPlayer.stopCountUp(true);
        }


        return super.abort(endValue, isAborted, multiplier);
    }

    /*protected getAbortAnimation(timeline:Timeline, endValue:number, multiplier:number):Timeline {
        timeline.add([
            () => {
                this._countUp.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.9 / this.getScale(multiplier);
                this._countUp.alpha = 1;
                this._countUp.visible = true;
                this._countUpContainer.scale.set(1, 1);
            },
            this._countUp.getCountUpAnimation(endValue, endValue, {duration : 0.01})
        ]);
    }*/

    protected getAbortAnimation(endValue:number, multiplier:number):Timeline {
        const timeline:TimelineLite = new TimelineLite();

        timeline.add([
            (!this._smallOrTiny && this._countUp.currentValue < endValue)? () => TractorBeamGameModuleConfig.soundPlayer.stopCountUp(true) : () => TractorBeamGameModuleConfig.soundPlayer.stopCountUp(false),
            () => {
                this._countUp.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.9 / this.getScale(multiplier);
                this._countUp.alpha = 1;
                this._countUp.visible = true;
                this._countUpContainer.scale.set(1, 1);
            },
            this._countUp.getCountUpAnimation(endValue, endValue, {duration : 0.01})
        ]);

        return timeline;
    }

    public getEndingAnimation():Timeline {
        const timeline:TimelineLite = new TimelineLite({
            onComplete : () => {
                this._isCountUpSoundPlaying = false;
                this._hasCountUpEndSoundPlayed = false;
            }
        });
        timeline.add(TweenLite.to(this._countUp, 0.5, {alpha : 0}), `+=0.8`); // stay a while after count up.

        return timeline;
    }
}
